import { Navigate, useLocation } from "react-router";

import {
    practiceSettingsPath,
    type ToolSettingsTab,
} from "./practiceSettings";

/**
 * Sends a tool's old settings address to its tab in practice settings.
 *
 * The old addresses are still reached from outside the app: the backend's
 * Stripe callback returns to `/payments/settings?stripe=…`, and therapists have
 * them bookmarked. The query string is kept so the tab can still read it.
 */
export default function PracticeSettingsRedirect({ tab }: { tab: ToolSettingsTab }) {
    const { search } = useLocation();
    const params = Object.fromEntries(new URLSearchParams(search));

    return <Navigate to={practiceSettingsPath(tab, params)} replace />;
}
